module.exports = __webpack_public_path__ + "img/s1_bg.8dfbd6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/dialog/UpgradeModal/images/s1_bg.png
// module id = MRCh
// module chunks = 47